var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 220,
    viewBox: "0 0 288 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H60V220H0V0Z",
    fill: "#101414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76 60H136V220H76V60Z",
    fill: "#101414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152 100H212V220H152V100Z",
    fill: "#101414"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M228 0H288V220H228V0Z",
    fill: "#101414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.c5db4372756f7906d47d4066560676ea.svg";
export { ForwardRef as ReactComponent };